// extracted by mini-css-extract-plugin
export default {"navigation":"WizardNavigation_navigation__V49pL"};